import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getBillingDetailsKey } from '../../utils/keys';
export const useUpdateBillingDetails = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.billing.updateDetails(input), {
        onSettled: () => {
            const billingDetailsKey = getBillingDetailsKey();
            queryClient.invalidateQueries(billingDetailsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateBillingDetails.js.map